(function () {
  function containsClassInClassList(classList, className) {
    for (var i = 0; i < classList.length; i++) {
      if (classList[i] === className) {
        return true
      }
    }
    return false
  }

  function linkPageType(elem) {
    // Normalize urls to always have a trailing slash
    let url = new URL(elem.href, 'https://' + location.host)
    let path = url.pathname;
    path = path.replace(/\/?$/, '/')
    if (path === '/' && elem.host === 'atlascoffeeclub.com') return 'homepage'
    if (path === '/collections/coffee-subscription-service/') return 'sub page'
    if (path === '/collections/the-perfect-gift-for-any-coffee-lover/') return 'gift page'
    if (path === '/collections/single-origin-coffee/') return 'our coffee page'
    if (path === '/cart/') return 'cart';
    if (/\/products\/[0-9]{1,2}-mo-gift/i.test(path)) return 'gift product page'
    if (url.host !== 'atlascoffeeclub.com') return 'external'
    if (containsClassInClassList(elem.classList, 'builder-button')) return "scroll_click"
    if (containsClassInClassList(elem.classList, 'faq-button')) return "faq_click"
    return 'other'
  }

  let clickHandler = function (e) {
    let elem = e.currentTarget
    let props = trackClickProps(elem)
    let pageType = linkPageType(elem)
    let eventName = 'click to ' + pageType
    if (pageType === "scroll_click") {
      eventName = 'scroll_click'
    }
    if (pageType === "faq_click") {
      eventName = 'faq_click'
      props = { ...props, question_text: props.linkText, path: window.location.pathname }
    }
    if (pageType === 'external') {
      window.analytics && analytics.track(eventName, props)
    } else {
      sendEvent(eventName, props)
    }
    return true;
  }

  let scrollHander = function (e) {
    let elem = e.currentTarget
    let props = trackClickProps(elem)

    window.analytics && analytics.track("scroll click", props)

    return true;
  }

  let findParentBlock = function (el) {
    while (el.parentNode) {
      el = el.parentNode;
      let blockName = el && el.dataset && el.dataset['block']
      if (blockName) return blockName;
    }
    return null;
  }
  let trackClickProps = function (e) {
    try {
      let elem = e // .currentTarget
      let linkText = elem.innerText && elem.innerText.trim();
      let linkType = 'button'
      let firstChild = elem.firstElementChild

      let destination = elem.href ? new URL(elem.href, 'https://' + location.host) : null;
      if (!!linkText) linkType = 'hyperlink';
      if (firstChild && firstChild.nodeName === 'IMG') linkType = 'image'
      if (firstChild && firstChild.nodeName === 'SVG') linkType = 'svg'
      if (firstChild && ['SPAN', 'DIV'].includes(firstChild.nodeName)) {
        linkText = linkText || firstChild.innerText
      }
      if (elem.className.includes('butn') || (firstChild && firstChild.classList.toString().includes('butn'))) {
        linkType = 'button'
      }

      return {
        originating_url: document.location.href,
        linkText: linkText,
        linkType: linkType,
        linkPath: destination && destination.pathname,
        link: destination && destination.toString(),
        linkSection: findParentBlock(elem)
      }
    } catch (err) {
      console.log(err)
      // We want to log the error but not throw an error to make sure we don't prevent the link from working properly
      window.Rollbar && Rollbar.error(err)
    }
  }

  window.sendEventsFromLocalStorage = function () {
    if (!window.localStorage) {
      Rollbar.warning("No localStorage")
      return;
    }
    let atlasEvent = window.localStorage.getItem('atlasEvent')
    if (!atlasEvent) return;
    atlasEvent = JSON.parse(atlasEvent)

    window.analytics && analytics.track(atlasEvent.eventName, atlasEvent.props)
    window.localStorage.removeItem('atlasEvent')
  }

  function sendEvent(eventName, props) {
    //console.log(eventName, props)
    if (window.localStorage && eventName !== "scroll_click" && eventName !== "faq_click") {
      let event = { eventName: eventName, props: props }
      window.localStorage.setItem('atlasEvent', JSON.stringify(event))
      return;
    }
    // fallback
    window.analytics && analytics.track(eventName, props)
  }

  var clickTrackReady = function (evt) {
    if (/^checkout/i.test(location.host)) {
      $(".shop a, .footer__copyright a, .call-to-action a").click(clickHandler)
    } else {
      // Scroll tracking
      $(".sign-up,.js-scroll,a[href^='#get']").each(function () {
        this.addEventListener('click', scrollHander)
      });
      $(".builder-button").each(function () {
        if (/modal/i.test(this.rel)) {
          this.addEventListener('click', clickHandler)
        } else {
          this.addEventListener('click', clickHandler)
          // let props = trackClickProps(this)
          // let eventName = 'click to ' + linkPageType(this)
          // analytics.trackLink(this, eventName, props )
        }
      });
      $(".faq-button").each(function () {
        if (/modal/i.test(this.rel)) {
          this.addEventListener('click', clickHandler)
        } else {
          this.addEventListener('click', clickHandler)
          // let props = trackClickProps(this)
          // let eventName = 'click to ' + linkPageType(this)
          // analytics.trackLink(this, eventName, props )
        }
      });
      $("a:not([href^='#'])").each(function () {
        if (/modal/i.test(this.rel)) {
          this.addEventListener('click', clickHandler)
        } else {
          this.addEventListener('click', clickHandler)
          // let props = trackClickProps(this)
          // let eventName = 'click to ' + linkPageType(this)
          // analytics.trackLink(this, eventName, props )
        }
      });
    }
  }

  if (
    document.readyState === "complete" || document.readyState !== "loading"
  ) {
    clickTrackReady();
  } else {
    document.addEventListener("DOMContentLoaded", clickTrackReady);
  }
}());

/*
(function() {
  window.ATLAS = window.ATLAS || {} 
  // Select Experiment
  if (!/mothersday22/i.test(window.ref_coupon)) {
    window.ATLAS.exp2334 = null; 
    return;
  }
  window.ATLAS.exp2334 = getParameterByName('exp2334') || Cookies.get('exp_acc2334')
  if (!window.ATLAS.exp2334 ) {
    let expRand = Math.random()*100.0;
    window.ATLAS.exp2334 = 'control';
    if(expRand < 33.333) {
      window.ATLAS.exp2334 = 'variant-a'  
    } else if (expRand < 66.666) {
      window.ATLAS.exp2334 = 'variant-b'  
    }
  }
  window.Cookies && Cookies.set('exp_acc2334', window.ATLAS.exp2334, { domain: '.atlascoffeeclub.com', expires: 365 });
}());
*/